import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QrConfigService {
  constructor(private http:HttpClient) { }


  qrConfig(data:any){
    return this.http.post(environment.apiUrl + "qrCodeConfig/addNew" , data);
  }
}